export default __webpack_public_path__ + "static/springandsummer (12)-2a05cf196502af716f0b162e84a2f1b8.jpeg";